import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import NumberInput from "../../../../components/inputs/number";
import CurrencyInput from "../../../../components/inputs/currency";
import Loading from "../../../../components/loading";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		control,
		errors,
		isSubmitting,
		handleSubmit,

		//hooks
		handleOnSubmit,
		handleCloseModalRegister,

		//variables
		isInsert,
		loading,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(handleOnSubmit)}
				>
					<main className="overflow-auto">
						<div className="row">
							<NumberInput
								label="Distância Máxima (km)"
								name="distancia"
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
							/>

							<CurrencyInput
								label="Valor da Taxa (R$)"
								name="valor"
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_taxa_entrega"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_taxa_entrega">
										<span className="text-lg">Taxa de entrega ativa</span>
									</label>
								</div>
							</div>
						</div>
					</main>

					<div className="flex justify-between flex-row-reverse p-1 mt-3">
						<BtnSubmit text="Salvar" isSubmitting={isSubmitting} />
						<BtnBack onClick={() => handleCloseModalRegister()} isSubmitting={isSubmitting} />
					</div>
				</form>
			)}
		</>
	);
};

export default Form;
